export enum PanelType {
  INFO = 'info',
}
